import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/meucorreios/dialog.css';
import '../../../assets/css/meucorreios/icones-correios.css';
import Input from '../../../components/form/Input';
import InputCadastro from '../../../components/form/InputCadastro';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createFormSchemas } from './FormSchema';
import SelectGenero from '../../../components/form/SelectGenero';
import {
  VALIDAR_E_ENVIAR_TOKEN,
  ENVIAR_TOKEN,
} from '../../../services/meuCorreios';
import {
  ALTERAR_MEUCORREIOS,
  NECESSIDADES_ESPECIAIS,
} from '../../../services/meuCorreios';
import InputToken from '../../../components/form/InputToken';
import useFetch from '../../../components/hooks/useFetch';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
//import { api } from '../../../services/Api';
import Tabela from '../../../components/tabela/Tabela';
import { format, parseISO } from 'date-fns';
import { toast } from 'react-toastify';
import '../../../assets/css/custom-toast.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import CheckboxGroup from '../../../components/form/CheckboxGroup';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';

function FormAlterarDadosBrasileiro() {
  const { t } = useTranslation();
  const { formSchemaAlteraDados } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaAlteraDados) });
  const [ipAddress, setIpAddress] = useState('');
  const [base64String, setBase64String] = useState('');
  const [file, setFile] = useState(null);
  const { request: requestRFB, data: dadosRFB } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const navigate = useNavigate();
  //  const { request: requestNecessidades, data: listaNecessidades } = useFetch();
  const {
    request: requestNecessidadesSelecionadas,
    data: listaNecessidadesSelecionadas,
  } = useFetch();

  let imagem = '';
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const [modalAbertoDados, setModalAbertoDados] = React.useState(true);
  const [modalAbertoToken, setModalAbertoToken] = React.useState(false);
  const listaNecessidades = [
    { id: 1, descricao: t('cadastro.forms.options.special_needs.physical') },
    { id: 2, descricao: t('cadastro.forms.options.special_needs.visual') },
    {
      id: 3,
      descricao: t('cadastro.forms.options.special_needs.intellectual'),
    },
    { id: 4, descricao: t('cadastro.forms.options.special_needs.auditory') },
    {
      id: 5,
      descricao: t('cadastro.forms.options.special_needs.psychosocial'),
    },
    { id: 6, descricao: t('cadastro.forms.options.special_needs.multiple') },
    { id: 7, descricao: t('cadastro.forms.options.special_needs.others') },
  ];
  React.useEffect(() => {
    if (dados) {
      //   requestNecessidades(LISTAR_NECESSIDADES_ESPECIAIS());
      requestNecessidadesSelecionadas(NECESSIDADES_ESPECIAIS(dados.idCorreios));
    }
    setSexo(dados?.usuarioExternoPF.sexo);
  }, [dados]);
  const [sexo, setSexo] = React.useState();
  const { request } = useFetch();
  const openModalToken = () => {
    setModalAbertoDados(false);
    setModalAbertoToken(true);
  };
  const tableMetadata = [
    { key: 'name', value: t('principal.edit_data.file_name') },
    { key: 'size', value: t('principal.edit_data.file_size') },
  ];
  const [nome, setNome] = React.useState();
  const [dataNascimento, setDataNascimento] = React.useState();
  const [necessidadesSelecionadas, setNecessidadesSelecionadas] =
    React.useState();
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      convertToBase64(file);
    }
  };
  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setBase64String(reader.result.split(',')[1]);
    };
    reader.onerror = (error) => {
      abreAlertaDialog(
        t('principal.edit_data.messages.image_conversion_error') + error,
      );
    };
  };
  const handleSubmit = async (data) => {
    const idsDosObjetos = listaNecessidadesSelecionadas.map((obj) =>
      String(obj.id),
    );
    if (
      dados.nome != data.nome ||
      dados.usuarioExternoPF.sexo != data.genero ||
      !(
        data.necessidadesEspeciais.length === idsDosObjetos.length &&
        data.necessidadesEspeciais.every((id) => idsDosObjetos.includes(id))
      ) ||
      (data.file && data.file.length === 1)
    ) {
      data.preventDefault;
      setNome(data.nome);
      setNecessidadesSelecionadas(data.necessidadesEspeciais);

      //if (meioEnvio == 'E') {
      // const token = {
      //   meioEnvio: meioEnvio,
      //   funcionalidade: 'ALTERAR_DADOS',
      //   email: dados.email,
      // }
      const dadosEnviar = {
        nome: data.nome.trim().toUpperCase(),
        idCorreios: dados.idCorreios,
        cpf: dados?.usuarioExternoPF.cpf,
        tipoEstrangeiro: dados.usuarioExternoPF.tipoEstrangeiro,
        tipoUsuario: 'PF',
        token: {
          meioEnvio: meioEnvio,
          funcionalidade: 'ALTERAR_DADOS',
          //email: dados.email,
        },
      };
      const { response } = await request(
        VALIDAR_E_ENVIAR_TOKEN(dadosEnviar, ipAddress),
      );
      if (response.ok) {
        if (meioEnvio == 'E') {
          abreAlertaDialog(t('principal.messages.success.token_sent_email'));
        } else {
          abreAlertaDialog(t('principal.messages.success.token_sent_phone'));
        }

        openModalToken();
      }
    } else {
      abreAlertaDialog(t('principal.messages.success.data_not_changed'));
    }
  };

  const [meioEnvio, setMeioEnvio] = React.useState('E');
  const handleMeioEnvio = (event) => {
    setMeioEnvio(event.target.value);
  };
  const alterar = async () => {
    const token =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token.length < 6) {
      abreAlertaDialog(
        t('principal.messages.validation.token_digits_required'),
      );
    } else {
      //const formatteddate = format(dataNascimento, 'yyyy-MM-dd');
      let imagem = base64String;
      if (imagem === '') {
        imagem = dados.usuarioExternoPF.imagem;
      }
      const dadosEnviar = {
        imagem: imagem,
        idCorreios: dados.idCorreios,
        nome: nome.trim().toUpperCase(),
        sexo: sexo,
        cpf: dados?.usuarioExternoPF.cpf,
        tipoEstrangeiro: dados.usuarioExternoPF.tipoEstrangeiro,
        token: token,
        necessidadesEspeciais: necessidadesSelecionadas,
      };
      const { response } = await request(
        ALTERAR_MEUCORREIOS(dadosEnviar, ipAddress),
      );
      if (response.ok) {
        abreAlertaDialog(t('principal.edit_data.messages.updated_success'));
        setModalAbertoToken(false);
        navigate('/principal');
      }
    }
  };
  const fechar = (ev) => {
    ev.preventDefault();
    setModalAbertoToken(false);
    navigate('/principal');
  };
  const handleReset = () => {
    const form = document.getElementById('formAlterarDados');
    const campos = form.querySelectorAll('input');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };
  const reenviaToken = async () => {
    const token = {
      meioEnvio: meioEnvio,
      funcionalidade: 'ALTERAR_DADOS',
    };
    const { response } = await request(ENVIAR_TOKEN(dados.idCorreios, token));
    if (response.ok) {
      if (meioEnvio == 'E') {
        abreAlertaDialog(t('principal.messages.success.token_sent_email'));
      } else {
        abreAlertaDialog(t('principal.messages.success.token_sent_phone'));
      }
      openModalToken();
    }
  };

  return (
    <>
      {modalAbertoDados ? (
        <div className="conteudo alterar-dados">
          <h1>{t('principal.edit_data.title')}</h1>
          <div
            id="cadastro-pf"
            className="cadastro-dados card bg-superficie elev1"
          >
            <form
              id="formAlterarDados"
              onSubmit={methods.handleSubmit(handleSubmit)}
            >
              <div className="dialog-main">
                <p className="subtitulo-p">
                  {t('principal.edit_data.profile_image')}
                </p>
                <div className="campo-perfil">
                  <img
                    id="input-img-perfil"
                    alt="Imagem de perfil"
                    src="/images/avatar-placeholder.svg"
                    width="100"
                    height="100"
                  />
                  {/*<img
                id="input-img-perfil"
                alt="Imagem de perfil"
                src={imageSrc}
                width="100"
                height="100"
              />*/}

                  <div className="inputfile-container">
                    <Input type="hidden" name="MAX_FILE_SIZE" value="1000" />
                    <Input
                      type="file"
                      name="file"
                      id="file"
                      className="inputfile esconder-visualmente"
                      accept="image/*"
                      onChange={handleFileChange}
                      {...formMethods}
                    />

                    <div className="legenda">
                      {t('principal.edit_data.image_requirements')}
                    </div>

                    <label htmlFor="file" className="inputfile-label">
                      {t('principal.edit_data.include_change_image')}
                    </label>
                  </div>
                </div>
                {file && <Tabela headers={tableMetadata} dados={[file]} />}

                <div className="campos-container">
                  <div className="campo-txt">
                    <label className="subtitulo-p" htmlFor="input-cpf">
                      {t('telaPrincipal.cpf')}
                    </label>

                    <Input
                      type="text"
                      id="cpf"
                      name="cpf"
                      placeholder=""
                      disabled
                      defaultValue={dados?.usuarioExternoPF.cpfFormatado}
                      {...formMethods}
                    />
                  </div>
                  <div className="mensagem legenda"></div>
                </div>

                <InputCadastro
                  type="text"
                  id="nome"
                  name="nome"
                  placeholder=""
                  maxLength="150"
                  label={t('cadastro.forms.labels.full_name')}
                  campoClassName="dado-nome"
                  defaultValue={dados?.nome}
                  {...formMethods}
                />

                <SelectGenero
                  id="genero"
                  name="genero"
                  label={t('cadastro.forms.labels.gender')}
                  value={sexo}
                  onChange={(e) => setSexo(e.target.value)}
                  {...formMethods}
                />

                <div className="campos">
                  <div className="controle">
                    {listaNecessidades ? (
                      <CheckboxGroup
                        //className="checks"
                        name="necessidadesEspeciais"
                        options={[
                          ...listaNecessidades.map((item) => ({
                            id: item.id,
                            value: item.id,
                            label: item.descricao,
                            checked: listaNecessidadesSelecionadas?.some(
                              (i) => i.id == item.id,
                            ),
                          })),
                        ]}
                        label={t('cadastro.forms.labels.special_needs')}
                        {...formMethods}
                      ></CheckboxGroup>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>

                {/*<div className="campo-txt">
              <label className="subtitulo-p" htmlFor="input-data">
                Nascimento
              </label>
              <InputCadastro
                className="input-data"
                type="date"
                id="dataNascimento"
                name="dataNascimento"
                defaultValue={dados?.usuarioExternoPF.dataNascimento}
                {...formMethods}
              />
            </div>*/}
                <div className="receber-token radio-container">
                  <p className="">
                    {t('principal.edit_data.token_delivery_question')}
                  </p>

                  <label className="radio">
                    <Input
                      type="radio"
                      id="E"
                      name="meioEnvio"
                      value="E"
                      checked={meioEnvio === 'E'}
                      onChange={handleMeioEnvio}
                      {...formMethods}
                    />
                    <div className="subtitulo-p">
                      {t('principal.forms.labels.email_option')}
                    </div>
                  </label>

                  <label className="radio">
                    <Input
                      type="radio"
                      id="C"
                      name="meioEnvio"
                      value="C"
                      //disabled="true"
                      checked={meioEnvio === 'C'}
                      onChange={handleMeioEnvio}
                      {...formMethods}
                    />
                    <div className="subtitulo-p">
                      {t('principal.forms.labels.phone_option')}
                    </div>
                  </label>
                </div>
              </div>
              <br />
              <div className="dialog-footer">
                <button className="btn-txt btn-fecha-dialog" onClick={fechar}>
                  {t('principal.forms.buttons.cancel')}
                </button>
                <button className="btn-pre" id="btn-dados" type="submit">
                  {t('principal.forms.buttons.change')}
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <form>
          <div id="finaliza-cadastro" className="conteudo">
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt="Imagem de perfil da Carol"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t('principal.forms.titles.finalize_change')}</h2>

              <p className="txt-finalizacao">
                {t('principal.edit_data.finalize_message')}
              </p>
              <div className="campo-txt">
                <InputToken />
              </div>
              <div className="btns-row">
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  {t('principal.forms.buttons.resend_code')}
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t('principal.forms.buttons.finalize')}
                </button>
                <button className="btn-txt btn-fecha-dialog" onClick={fechar}>
                  {t('principal.forms.buttons.cancel')}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}
export default FormAlterarDadosBrasileiro;
